import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { FaLaptopCode, FaMobileAlt, FaCloud, FaRobot, FaGraduationCap, FaLightbulb, FaUsers, FaChartLine, FaArrowRight, FaStar } from 'react-icons/fa';
import "./home.css"

const Home = () => {
    const [scrollY, setScrollY] = useState(0);
    const [activeCard, setActiveCard] = useState(null);

    useEffect(() => {
        const handleScroll = () => setScrollY(window.scrollY);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const aboutCards = [
        { icon: FaLightbulb, title: "Our Mission", text: "Building innovative, scalable software solutions that empower businesses and individuals.", color: "linear-gradient(135deg, #fbbf24 0%, #f97316 100%)" },
        { icon: FaUsers, title: "Our Team", text: "Highly skilled professionals specializing in cutting-edge technologies.", color: "linear-gradient(135deg, #60a5fa 0%, #06b6d4 100%)" },
        { icon: FaLaptopCode, title: "Our Expertise", text: "Custom software, web/mobile apps, cloud solutions, AI/ML, and IoT.", color: "linear-gradient(135deg, #a78bfa 0%, #ec4899 100%)" },
        { icon: FaChartLine, title: "Our Approach", text: "Tailored solutions to meet unique needs and drive growth.", color: "linear-gradient(135deg, #4ade80 0%, #10b981 100%)" }
    ];

    const services = [
        { icon: FaLaptopCode, title: "Custom Software", text: "Tailored solutions designed specifically for your business requirements.", gradient: "linear-gradient(135deg, #6366f1 0%, #a855f7 50%, #ec4899 100%)" },
        { icon: FaMobileAlt, title: "Mobile Apps", text: "iOS and Android applications with stunning UI/UX.", gradient: "linear-gradient(135deg, #06b6d4 0%, #3b82f6 50%, #6366f1 100%)" },
        { icon: FaCloud, title: "Cloud Solutions", text: "Scalable cloud infrastructure and services.", gradient: "linear-gradient(135deg, #4ade80 0%, #14b8a6 50%, #06b6d4 100%)" },
        { icon: FaRobot, title: "AI & ML", text: "Intelligent systems powered by artificial intelligence.", gradient: "linear-gradient(135deg, #fb923c 0%, #ef4444 50%, #ec4899 100%)" }
    ];

    return (
        <div style={{ background: 'linear-gradient(to bottom right, #0f172a 0%, #2b3da3ff 50%, #0f172a 100%)', minHeight: '100vh', position: 'relative', overflow: 'hidden' }}>
            {/* Animated background particles */}
            <div style={{ position: 'fixed', inset: 0, overflow: 'hidden', pointerEvents: 'none' }}>
                {[...Array(20)].map((_, i) => (
                    <div
                        key={i}
                        style={{
                            position: 'absolute',
                            width: '8px',
                            height: '8px',
                            background: '#a78bfa',
                            borderRadius: '50%',
                            opacity: 0.2,
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                            animation: `pulse ${2 + Math.random() * 3}s ease-in-out infinite`,
                            animationDelay: `${Math.random() * 3}s`
                        }}
                    />
                ))}
            </div>

            {/* Hero Section */}
            <section style={{ position: 'relative', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        backgroundImage: 'url(/assets/site_img21.jpg)',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        transform: `translateY(${scrollY * 0.5}px)`,
                        filter: 'brightness(0.3)'
                    }}
                />
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, transparent 0%, rgba(36, 46, 184, 0.5) 50%, #0f172a 100%)' }} />

                <Container style={{ position: 'relative', zIndex: 10, textAlign: 'center' }}>
                    <div style={{ animation: 'fadeIn 1s ease-out' }}>
                        <div style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            background: 'rgba(255, 255, 255, 0.1)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '50px',
                            padding: '12px 24px',
                            marginBottom: '32px',
                            border: '1px solid rgba(255, 255, 255, 0.2)'
                        }}>
                            <FaStar style={{ color: '#fcd34d', animation: 'pulse 2s ease-in-out infinite' }} />
                            <span style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Welcome to the Future</span>
                        </div>

                        <h1 style={{ fontSize: 'clamp(3rem, 8vw, 6rem)', fontWeight: 'bold', color: 'white', marginBottom: '24px', lineHeight: 1.2 }}>
                            Innovative
                            <span style={{
                                display: 'block',
                                marginTop: '8px',
                                background: 'linear-gradient(90deg, #06b6d4 0%, #a78bfa 50%, #ec4899 100%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundSize: '200% 200%',
                                animation: 'gradient 3s ease infinite'
                            }}>
                                Software Solutions
                            </span>
                        </h1>

                        <p style={{ fontSize: 'clamp(1.125rem, 2vw, 1.5rem)', color: '#d1d5db', marginBottom: '48px', maxWidth: '900px', margin: '0 auto 48px' }}>
                            Transforming your ideas into powerful digital experiences that shape tomorrow
                        </p>

                        <Button
                            size="lg"
                            style={{
                                background: 'linear-gradient(90deg, #06b6d4 0%, #8b5cf6 100%)',
                                border: 'none',
                                borderRadius: '50px',
                                padding: '16px 32px',
                                fontSize: '18px',
                                fontWeight: 600,
                                transition: 'all 0.3s ease',
                                boxShadow: '0 20px 40px rgba(139, 92, 246, 0.3)'
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.transform = 'scale(1.05)';
                                e.currentTarget.style.boxShadow = '0 25px 50px rgba(139, 92, 246, 0.5)';
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.transform = 'scale(1)';
                                e.currentTarget.style.boxShadow = '0 20px 40px rgba(139, 92, 246, 0.3)';
                            }}
                            href='#services'
                        >
                            Get Started <FaArrowRight style={{ marginLeft: '8px' }} />
                        </Button>
                    </div>
                </Container>

                {/* Scroll indicator */}
                <div style={{ position: 'absolute', bottom: '40px', left: '50%', transform: 'translateX(-50%)', animation: 'bounce 2s ease-in-out infinite' }}>
                    <div style={{ width: '24px', height: '40px', border: '2px solid rgba(255, 255, 255, 0.3)', borderRadius: '20px', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '8px' }}>
                        <div style={{ width: '4px', height: '12px', background: 'rgba(255, 255, 255, 0.5)', borderRadius: '4px' }} />
                    </div>
                </div>
            </section>

            {/* About Section */}
            <section style={{ position: 'relative', padding: '100px 0' }}>
                <Container>
                    <div style={{ textAlign: 'center', marginBottom: '64px' }}>
                        <h2 style={{ fontSize: 'clamp(2.5rem, 5vw, 4rem)', fontWeight: 'bold', color: 'white', marginBottom: '16px' }}>
                            Code<span style={{ background: 'linear-gradient(90deg, #06b6d4 0%, #a78bfa 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Flex</span>
                        </h2>
                        <div style={{ width: '96px', height: '4px', background: 'linear-gradient(90deg, #06b6d4 0%, #a78bfa 100%)', margin: '0 auto', borderRadius: '4px' }} />
                    </div>

                    <Row>
                        {aboutCards.map((card, index) => (
                            <Col key={index} md={6} lg={3} className="mb-4">
                                <Card
                                    onMouseEnter={() => setActiveCard(index)}
                                    onMouseLeave={() => setActiveCard(null)}
                                    style={{
                                        height: '100%',
                                        background: 'rgba(255, 255, 255, 0.05)',
                                        backdropFilter: 'blur(10px)',
                                        border: '1px solid rgba(255, 255, 255, 0.1)',
                                        borderRadius: '16px',
                                        padding: '24px',
                                        transition: 'all 0.5s ease',
                                        transform: activeCard === index ? 'scale(1.05) translateY(-10px)' : 'scale(1)',
                                        boxShadow: activeCard === index ? '0 20px 40px rgba(139, 92, 246, 0.3)' : 'none',
                                        position: 'relative',
                                        overflow: 'hidden'
                                    }}
                                >
                                    <div style={{
                                        position: 'absolute',
                                        inset: 0,
                                        background: card.color,
                                        opacity: activeCard === index ? 0.1 : 0,
                                        transition: 'opacity 0.5s ease'
                                    }} />

                                    <Card.Body style={{ position: 'relative', zIndex: 1, padding: 0 }}>
                                        <div style={{
                                            width: '64px',
                                            height: '64px',
                                            borderRadius: '12px',
                                            background: card.color,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            margin: '0 auto 16px',
                                            transition: 'transform 0.5s ease',
                                            transform: activeCard === index ? 'rotate(12deg)' : 'rotate(0deg)'
                                        }}>
                                            <card.icon style={{ fontSize: '32px', color: 'white' }} />
                                        </div>

                                        <Card.Title style={{ color: 'white', fontSize: '20px', fontWeight: 'bold', marginBottom: '12px' }}>
                                            {card.title}
                                        </Card.Title>
                                        <Card.Text style={{ color: '#9ca3af', lineHeight: 1.6 }}>
                                            {card.text}
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* Services Section */}
            <section id='services' style={{ position: 'relative', padding: '100px 0' }}>
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, transparent 0%, rgba(88, 28, 135, 0.2) 50%, transparent 100%)' }} />

                <Container style={{ position: 'relative' }}>
                    <div style={{ textAlign: 'center', marginBottom: '64px' }}>
                        <h2 style={{ fontSize: 'clamp(2.5rem, 5vw, 4rem)', fontWeight: 'bold', color: 'white', marginBottom: '16px' }}>
                            Our Services
                        </h2>
                        <p style={{ fontSize: '20px', color: '#9ca3af' }}>Cutting-edge solutions for modern challenges</p>
                    </div>

                    <Row>
                        {services.map((service, index) => (
                            <Col key={index} md={6} lg={3} className="mb-4">
                                <Card
                                    style={{
                                        height: '100%',
                                        background: 'rgba(255, 255, 255, 0.05)',
                                        backdropFilter: 'blur(10px)',
                                        border: '1px solid rgba(255, 255, 255, 0.1)',
                                        borderRadius: '16px',
                                        padding: '24px',
                                        transition: 'all 0.5s ease',
                                        position: 'relative',
                                        overflow: 'hidden',
                                        cursor: 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-8px)';
                                        e.currentTarget.style.boxShadow = '0 20px 40px rgba(139, 92, 246, 0.3)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = 'none';
                                    }}
                                >
                                    <Card.Body style={{ position: 'relative', zIndex: 1, padding: 0 }}>
                                        <div style={{
                                            width: '64px',
                                            height: '64px',
                                            borderRadius: '12px',
                                            background: service.gradient,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            margin: '0 auto 16px',
                                            transition: 'all 0.5s ease'
                                        }}
                                            onMouseOver={(e) => {
                                                e.currentTarget.style.transform = 'scale(1.1) rotate(6deg)';
                                            }}
                                            onMouseOut={(e) => {
                                                e.currentTarget.style.transform = 'scale(1) rotate(0deg)';
                                            }}
                                        >
                                            <service.icon style={{ fontSize: '32px', color: 'white' }} />
                                        </div>

                                        <Card.Title style={{ color: 'white', fontSize: '20px', fontWeight: 'bold', marginBottom: '12px' }}>
                                            {service.title}
                                        </Card.Title>
                                        <Card.Text style={{ color: '#9ca3af', lineHeight: 1.6 }}>
                                            {service.text}
                                        </Card.Text>

                                        {/* <div style={{ display: 'flex', alignItems: 'center', color: '#06b6d4', fontWeight: 500 }}>
                                            Learn More <FaArrowRight style={{ marginLeft: '8px', transition: 'transform 0.3s ease' }} />
                                        </div> */}
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* Careers Section */}
            <section style={{ position: 'relative', padding: '100px 0' }}>
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10}>
                            <div style={{
                                background: 'linear-gradient(135deg, rgba(88, 28, 135, 0.4) 0%, rgba(219, 39, 119, 0.4) 100%)',
                                backdropFilter: 'blur(20px)',
                                borderRadius: '24px',
                                padding: '48px',
                                border: '1px solid rgba(255, 255, 255, 0.1)',
                                position: 'relative',
                                overflow: 'hidden'
                            }}>
                                <div style={{ position: 'absolute', top: 0, right: 0, width: '256px', height: '256px', background: 'radial-gradient(circle, rgba(139, 92, 246, 0.3) 0%, transparent 70%)', filter: 'blur(60px)' }} />
                                <div style={{ position: 'absolute', bottom: 0, left: 0, width: '256px', height: '256px', background: 'radial-gradient(circle, rgba(6, 182, 212, 0.3) 0%, transparent 70%)', filter: 'blur(60px)' }} />

                                <div style={{ position: 'relative', zIndex: 1 }}>
                                    <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 'bold', color: 'white', marginBottom: '16px' }}>
                                        Careers at CodeFlex
                                    </h2>
                                    <p style={{ fontSize: '20px', color: '#d1d5db', marginBottom: '48px' }}>
                                        Join our team of innovators and work on exciting projects with cutting-edge technologies.
                                    </p>

                                    <div style={{
                                        background: 'rgba(255, 255, 255, 0.05)',
                                        backdropFilter: 'blur(10px)',
                                        borderRadius: '16px',
                                        padding: '32px',
                                        border: '1px solid rgba(255, 255, 255, 0.1)'
                                    }}>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column', // ✅ stack vertically
                                            alignItems: 'center',    // ✅ center horizontally
                                            textAlign: 'center', gap: '16px', marginBottom: '24px', flexWrap: 'wrap'
                                        }}>
                                            <div style={{
                                                width: '64px',
                                                height: '64px',
                                                borderRadius: '12px',
                                                background: 'linear-gradient(135deg, #fbbf24 0%, #f97316 100%)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flexShrink: 0
                                            }}>
                                                <FaGraduationCap style={{ fontSize: '32px', color: 'white' }} />
                                            </div>
                                            <div style={{ flex: 1, minWidth: '200px' }}>
                                                <h4 style={{ fontSize: '24px', fontWeight: 'bold', color: 'white', marginBottom: '12px' }}>
                                                    Internship Program
                                                </h4>
                                                <p style={{ color: '#9ca3af', lineHeight: 1.6, marginBottom: 0 }}>
                                                    Gain real-world experience and mentorship from industry experts. Our internship program is designed to help you grow your skills and kickstart your career in tech.
                                                </p>
                                            </div>
                                        </div>

                                        <Button
                                            style={{
                                                background: 'linear-gradient(90deg, #fbbf24 0%, #f97316 100%)',
                                                border: 'none',
                                                borderRadius: '50px',
                                                padding: '12px 24px',
                                                fontWeight: 600,
                                                transition: 'all 0.3s ease'
                                            }}
                                            onMouseOver={(e) => {
                                                e.currentTarget.style.transform = 'scale(1.05)';
                                            }}
                                            onMouseOut={(e) => {
                                                e.currentTarget.style.transform = 'scale(1)';
                                            }}
                                            href='/contact_us'
                                        >
                                            Apply Now <FaArrowRight style={{ marginLeft: '8px' }} />
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Contact CTA */}
            <section style={{ position: 'relative', padding: '100px 0' }}>
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <div style={{
                                background: 'linear-gradient(90deg, #0891b2 0%, #7c3aed 100%)',
                                borderRadius: '24px',
                                padding: '64px 32px',
                                textAlign: 'center',
                                position: 'relative',
                                overflow: 'hidden'
                            }}>
                                <div style={{
                                    position: 'absolute',
                                    inset: 0,
                                    backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 30px, rgba(255, 255, 255, 0.03) 30px, rgba(255, 255, 255, 0.03) 60px)',
                                    opacity: 0.3
                                }} />

                                <div style={{ position: 'relative', zIndex: 1 }}>
                                    <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 'bold', color: 'white', marginBottom: '16px' }}>
                                        Ready to Start Your Project?
                                    </h2>
                                    <p style={{ fontSize: '20px', color: 'rgba(255, 255, 255, 0.9)', marginBottom: '32px' }}>
                                        Let's build something amazing together
                                    </p>

                                    <Button
                                        size="lg"
                                        style={{
                                            background: 'white',
                                            color: '#7c3aed',
                                            border: 'none',
                                            borderRadius: '50px',
                                            padding: '16px 32px',
                                            fontWeight: 600,
                                            fontSize: '18px',
                                            transition: 'all 0.3s ease',
                                            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)'
                                        }}
                                        onMouseOver={(e) => {
                                            e.currentTarget.style.transform = 'scale(1.05)';
                                            e.currentTarget.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.3)';
                                        }}
                                        onMouseOut={(e) => {
                                            e.currentTarget.style.transform = 'scale(1)';
                                            e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.2)';
                                        }}
                                        href='/contact_us'
                                    >
                                        Contact Us <FaArrowRight style={{ marginLeft: '8px' }} />
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <style>{`
                @keyframes gradient {
                    0%, 100% { background-position: 0% 50%; }
                    50% { background-position: 100% 50%; }
                }
                
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                @keyframes bounce {
                    0%, 100% {
                        transform: translateX(-50%) translateY(0);
                    }
                    50% {
                        transform: translateX(-50%) translateY(-10px);
                    }
                }
                
                @keyframes pulse {
                    0%, 100% {
                        opacity: 0.2;
                        transform: scale(1);
                    }
                    50% {
                        opacity: 0.5;
                        transform: scale(1.1);
                    }
                }
            `}</style>
        </div>
    );
};

export default Home;